export default defineNuxtRouteMiddleware((to, from) => {
  console.debug("router middleware", { to, from });
  if (to.path !== "/referrals") {
    console.debug("referrals redirect", { from, to });
  }
});
